import { VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VDataTable } from 'vuetify/lib'
import moment from 'moment'
import { getsafe } from '@/libs/util.js'
import styles from './index.module.less'
import {mapGetters} from "vuex";
const Item = {
    props: {
        detail: {
            type: Object,
        },
        fromDate: {
            type: String,
            default: '2021-06-05'
        },
        toDate: {
            type: String,
            default: '2021-07-01'
        },
        person: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        summarizeInfo() {
            // 实习生考勤数据在同一个团队下可能出现多个分段
            const account = getsafe(this.detail, 'account', '-')
            const salary_list = getsafe(this.detail, 'salary_list', []) || []
            // 只有一条分段时直接返回info
            if (salary_list.length === 0) {
                return `${account}-无考勤数据`
            }
            if (salary_list.length === 1) {
                const info = getsafe(salary_list, '0.detail.info', '-')
                return `${account}-${info}`
            }
            // 如果有多条分段需要拼凑数据
            let meal_subsidy_days = math.eval(`0`)
            let wage_days = math.eval(`0`)
            let bonus = math.eval(`0`)
            salary_list.forEach(item => {
                const meal_subsidy_days_item = getsafe(item, 'detail.meal_subsidy_days', '0')
                const wage_days_item = getsafe(item, 'detail.wage_days', '0')
                const bonus_item = getsafe(item, 'detail.bonus.total_money', '0')
                meal_subsidy_days = math.eval(`${meal_subsidy_days_item}+${meal_subsidy_days}`)
                wage_days = math.eval(`${wage_days_item}+${wage_days}`)
                bonus = math.eval(`${bonus_item}+${bonus}`)
            })
            meal_subsidy_days = meal_subsidy_days.toNumber()
            wage_days = wage_days.toNumber()
            bonus = bonus.toNumber()
            return `${account}/换算发薪总计${wage_days}日/总发餐补天数${meal_subsidy_days}日/奖金${bonus}`
        },
        content() {
            /* --------------------------- 打卡日期作为 key 的 hash------------------------------- */
            const hash = {}
            const list = [{}]
            let current = this.fromDate
            const end = this.toDate
            const salary_list = getsafe(this.detail, 'salary_list', []) || []
            salary_list.forEach(salaryDetail => {
               const detail = getsafe(salaryDetail, 'detail.day_list', []) || []
               const root_team_id = getsafe(salaryDetail, 'root_team_id')
               const root_team_name = this.teams_hash[root_team_id] ? this.teams_hash[root_team_id].name : ''
               detail.forEach(item => {
                    if (!hash[item.day]) {
                        hash[item.day] = []
                    }
                    hash[item.day].push({...item, root_team_id, root_team_name})
               })
            })
    
            // let day_list = this.detail.day_list
            // day_list = [...day_list]
            // day_list.forEach(item => {
            //   hash[item.day] = item
            // })
            /* ----------------------- 将数据按一周为一个单位来聚合 ----------------------- */
            while (moment(current).isBefore(end) || current === end) {
                    let current_o = list[list.length - 1]
                   
                    const day_o = moment(current).day()
                    if (day_o === 0) {
                        current_o = {}
                        list.push(current_o)
                    }
                  
                    current_o[day_o] = hash[current] || {
                        nodata: true,
                        day: current
                    }// workHand(hash[current], current)
                
                    current = moment(current).add(1, 'day').format('YYYY-MM-DD')
            }
            const first = list[0]
            if (Object.keys(first).length === 0) {
                list.shift()
            }
            return list
        },
        colunms() {
            return [
                // {
                //     text: '-',
                //     value: 'k',
                //     align: 'center'
                // },
                {
                    text: '星期日',
                    value: '0',
                    align: 'center'
                },
                {
                    text: '星期一',
                    value: '1',
                    align: 'center'
                },
                {
                    text: '星期二',
                    value: '2',
                    align: 'center'
                },
                {
                    text: '星期三',
                    value: '3',
                    align: 'center'
                },
                {
                    text: '星期四',
                    value: '4',
                    align: 'center'
                },
                {
                    text: '星期五',
                    value: '5',
                    align: 'center'
                },
                {
                    text: '星期六',
                    value: '6',
                    align: 'center'
                },
            ]
        },
        ...mapGetters({
            // companies_hash: 'async/companies_hash',
            teams_hash: 'async/root_teams_hash',
            // jobs_hash: 'async/jobs_hash',
        }),
    },
    mounted() {
      //   console.log('this',this.detail.data_list)
    },
    methods: {
        dayDis({header, item}) {
           
            const key = header.value
            const data = item[key]
            if (!data) {
                return <td></td>
            }
            if (data.nodata) {
                const day = data.day
             
                return <td>
                     <div class={styles['td-div']}>
                    <p
                     style={{
                         align: 'left',
                         marginBottom: '8px',

                     }}
                    >
                        {`${day.slice(-2)}号`}
                     <span class={styles['month-mark']}>{Number(day.slice(-2)) === 1 && `${Number(data.day.slice(5, 7))}月`}</span>
                   </p>
                   <p>无数据</p>
                   </div>
                </td>
            }
            
             const day = getsafe(data, '0.day')// data[0] || ''
         
            return <td>
             <div class={styles['td-div']}>
                   <p
                    style={{
                        align: 'left',
                        marginBottom: '8px',

                    }}
                   >{`${day.slice(-2)}号`}
                    <span class={styles['month-mark']}>{Number(day.slice(-2)) === 1 && `${Number(day.slice(5, 7))}月`}</span>
                  </p>
                  {data.map((item, index) => {
                    const {is_at_office, wage_percent, bonus, tip, leader_name, root_team_name} = item
                    return <div class={styles['td-contain']} key={index}>
                    <p style="margin-bottom: 0px">leader：{leader_name}</p>
                    <p style="margin-bottom: 0px">团队：{root_team_name}</p>
                    <p style="margin-bottom: 0px">
                        在办公室：<span class={styles['val']}>{is_at_office ? '是' : '否'}</span>
                    </p>
                    <p style={{
                        'margin-bottom': '0px',
                        background: wage_percent !== 1 ? 'rgba(255,153,0,0.4)' : ''
                    }}>
                        工作时长：<span class={styles['val']}>{wage_percent}天</span>
                    </p>
                    <p style="margin-bottom: 0px">
                        奖金：<span class={styles['val']}>{bonus}</span>
                    </p>
                    <p style="margin-bottom: 0px">
                        备注：<span class={styles['val']}>{tip}</span>
                    </p>
              </div>
                  })}
                   
                   
               </div>
            </td> 
        }
    },
    render() {
    
        const _this = this
       
        return <VExpansionPanel>
            <VExpansionPanelHeader>
                 { this.summarizeInfo }
            </VExpansionPanelHeader>
            <VExpansionPanelContent>
                <div class={styles['disable-hover']}>
                    <VDataTable
                        headers={_this.colunms}
                        disable-pagination
                        disable-sort
                        hide-default-footer
                        items={_this.content}
                        scopedSlots={{
                            'no-data': () => {
                                return <div>
                                暂无数据
                              </div>
                            },
                            item: ({item, headers, index}) => {
                                item = item || {}
                                return <tr>
                                    {headers.map(header => {
                                        return this.dayDis({
                                            header,
                                            item
                                        })
                                      
                                    })}
                                </tr>}
                        }}
                    />                    
                </div>

            </VExpansionPanelContent>
        </VExpansionPanel>
    }
}
const contain = {
    props: {
        list: {
            type: Array,
        },
        fromDate: {
            type: String,
        },
        toDate: {
            type: String,
        },
        informalsHash: {
            type: Object,
            default: () => ({})
        }
    },
    render() {
        const _this = this
        return <div>
            <VExpansionPanels
            multiple>
                    {_this.list.map(item => {
                       
                        return <Item
                        detail={item}
                        fromDate={_this.fromDate}
                        toDate={_this.toDate}
                        person = {_this.informalsHash && _this.informalsHash[item.customer_id] || {}}
                    />
                    })}
            </VExpansionPanels>
        </div>
    }
}

export default contain